export function makeGroupedRows (filteredTransactions, transactionsRollup, context) {
  console.log('makeGroupedRows', context)

  const rows = []

  const rowsRollingParams = {
    currentDate: null,
    currentPairId: null,
    breakCounter: 0
  }

  const transactionsRollupFiltered = transactionsRollupForFilteredTransactions(transactionsRollup)

  transactionsRollupFiltered.forEach(function (rollupMapValue) {
    const dateGroup = rollupMapValue[0]
    const entitiesPairId = rollupMapValue[1]
    const rollupValue = rollupMapValue[2]

    if (dateGroup !== rowsRollingParams.currentDate) {
      rowsRollingParams.currentDate = dateGroup
      rowsRollingParams.currentPairId = null // Reset for new dateGroup

      rows.push({
        type: 'dateGroup',
        dateGroup,
        rowId: `date-${dateGroup}`
      })
    }

    if (entitiesPairId !== rowsRollingParams.currentPairId) {
      rowsRollingParams.currentPairId = entitiesPairId

      rows.push({
        type: 'entityPair',
        entitiesPair: rollupValue._entitiesPair,
        rollupValue,
        rowId: `entityPair-${dateGroup}-${entitiesPairId}`
      })
    }

    rollupValue.filteredGroupTransactions?.forEach(function (transaction) {
      rows.push({
        type: 'transaction',
        transaction,
        rowId: transaction.ledger_id
      })
    })

    rows.push(makeBreakRow(rowsRollingParams))
  })

  return rows
}

function makeBreakRow (rowsRollingParams) {
  rowsRollingParams.breakCounter++
  return {
    type: 'break',
    rowId: `break-${rowsRollingParams.breakCounter}`
  }
}

function transactionsRollupForFilteredTransactions (transactionsRollup) {
  const rollup = []

  transactionsRollup.forEach(function (rollupMapValue) {
    const dateGroup = rollupMapValue[0]
    const entitiesPairId = rollupMapValue[1]
    const rollupValue = rollupMapValue[2]

    const filteredGroupTransactions = rollupValue.groupTransactions.filter(transaction => transaction._isPassingFilter)

    if (filteredGroupTransactions.length === 0) return

    const updatedRollupValue = {
      ...rollupValue,
      filteredGroupTransactions
    }

    rollup.push([
      dateGroup,
      entitiesPairId,
      updatedRollupValue
    ])
  })

  return rollup
}
